if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.querySelector('[data-bw-media-controls]')?.addEventListener('pointerup', event => event.stopPropagation());
      this.querySelector('[data-bw-media-previous]')?.addEventListener('click', () => this.moveMedia(-1));
      this.querySelector('[data-bw-media-next]')?.addEventListener('click', () => this.moveMedia(1));
      this.addEventListener('keydown', event => {
        if (!this.hasAttribute('open') || event.target.closest('input,select,textarea,video,model-viewer')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          this.moveMedia(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
      document.dispatchEvent(new CustomEvent('bw:gallery-open'));
    }

    showActiveMedia() {
      const id = this.openedBy.getAttribute('data-media-id');
      const content = this.querySelector('.product-media-modal__content');
      this.mediaItems = Array.from(content.children).filter(element => element.dataset.mediaId &&
        (!element.classList.contains('product__media-item--variant') || element.dataset.mediaId === id));
      this.activeIndex = Math.max(0, this.mediaItems.findIndex(element => element.dataset.mediaId === id));
      this.activateMedia();
    }

    moveMedia(direction) {
      if (!this.mediaItems?.length) return;
      this.activeIndex = (this.activeIndex + direction + this.mediaItems.length) % this.mediaItems.length;
      window.pauseAllMedia();
      this.activateMedia();
      document.dispatchEvent(new CustomEvent('bw:gallery-next'));
    }

    activateMedia() {
      const active = this.mediaItems[this.activeIndex];
      if (!active) return;
      this.querySelectorAll('.product-media-modal__content > [data-media-id]').forEach(element => {
        element.classList.toggle('active', element === active);
      });
      if (active.tagName === 'IMG') active.loading = 'eager';
      const content = this.querySelector('.product-media-modal__content');
      content.scrollTop = 0;
      content.scrollLeft = 0;
      const counter = this.querySelector('.bw-media-counter');
      if (counter) counter.textContent = `${this.activeIndex + 1} / ${this.mediaItems.length}`;
      this.querySelectorAll('[data-bw-media-previous],[data-bw-media-next]').forEach(button => {
        button.disabled = this.mediaItems.length < 2;
      });
      const template = active.querySelector('template');
      if (active.tagName === 'DEFERRED-MEDIA' && template?.content.querySelector('.js-youtube')) active.loadContent();
    }
  });
}
